<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.workStyles
</script>

<div class="{klass}">
	<FormWithLabel
		label="勤務形態"
		input={service.handleWorkStyles}
		values={$model.workStyles}
		inputType="checkboxes"
		options={$models}
	/>
</div>